<template>
  <div style="padding-left: 10px;padding-right: 10px;min-width: 200px;max-width: 300px;max-height: 250px;overflow: auto">
    <div class="col-xs-12">
      <span>Filter by Publications</span>

    </div>
    <div class="col-xs-12" style="margin-top: 5px">
      <div class="row">
        <div class="col-xs-6">
          <a role="button" class="text-info"
             style="font-size: 12px;font-weight: normal;font-style: italic;" @click="feedFilter"> Select All</a>
        </div>
        <div class="col-xs-6 text-right">
          <a role="button" class="text-info"
             style="font-size: 12px;font-weight: normal;font-style: italic;" @click="clearFilter"> Clear All</a>
        </div>
      </div>
    </div>
    <div class="col-xs-12" style="margin-top: 5px">
      <div v-for="(publication, key) in publications" :key="key" style="padding-top: 10px">
        <div class="checkbox checkbox-info checkbox-inline">
          <input :id="uniqId + 'checkbox-publication-' + publication.name" type="checkbox"
                 v-on:change="publicationSelected(publication)" v-bind:checked="checked(publication)"
                 :disabled="publication.nb === 0">
          <label :for="uniqId + 'checkbox-publication-' + publication.name">
            <template v-if="!publication.name">Undefined</template><template v-else>{{publication.name}}</template> ({{publication.nb}})
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .pe-ul > li {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .pe-ul > li > i{
    color: #62cb31;
    font-weight: bold;
  }

  .pe-ul > li > span{
    font-size: 14px;
    font-weight: normal;
  }

</style>
<script>

export default {
  components: {},
  props: ['publications', 'publicationsSelected'],
  name: 'PublicationBox',
  data () {
    return {
      uniqId: ''
    }
  },
  methods: {
    checked: function (publication) {
      if (this.publicationsSelected.length !== 0) {
        let tmpPublicationSelected = this.publicationsSelected.find((publicationSelected) => {
          return publicationSelected.name === publication.name
        })
        if (typeof tmpPublicationSelected !== 'undefined') {
          return true
        }
      }
      return false
    },
    publicationSelected: function (publication) {
      let index = this.publicationsSelected.map((e) => {
        return e.name
      }).indexOf(publication.name)

      if (index === -1) {
        this.publicationsSelected.push(publication)
      } else {
        this.publicationsSelected.splice(index, 1)
      }
    },
    clearFilter: function (event) {
      this.publicationsSelected.splice(0, this.publicationsSelected.length)
      event.preventDefault()
    },
    feedFilter: function (event) {
      this.clearFilter(event)

      this.publications.forEach((publication) => {
        this.publicationsSelected.push(publication)
      })
      event.preventDefault()
    }
  },
  beforeMount () {
    this.uniqId = Math.random().toString()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filter/PublicationBox.vue